/**
 * Firebase Auth initialization.
 *
 * Used exclusively by the "Continue with Apple" button. Firebase Auth handles
 * the Apple Sign In credential exchange and issues a Firebase ID token, which
 * is then sent to the backend's /users/auth/sync endpoint for verification
 * (the backend tries Neon JWT first, then falls back to Firebase JWT).
 *
 * Configuration is provided via EXPO_PUBLIC_FIREBASE_* environment variables
 * (set in .env, .env.staging, or EAS environment). All five values come from
 * the Firebase Console → Project Settings → General → Web Apps → SDK setup.
 */
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, OAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.EXPO_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID,
  appId: process.env.EXPO_PUBLIC_FIREBASE_APP_ID,
  // storageBucket and messagingSenderId are optional for Auth-only usage
  storageBucket: process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
};

// Avoid double-initialization on hot reload / Fast Refresh
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(app);

/** Apple OAuth provider — used for both popup (web) and credential (native) flows. */
export const appleProvider = new OAuthProvider('apple.com');

// Request the email and name scopes (Apple requires explicit scope requests)
appleProvider.addScope('email');
appleProvider.addScope('name');
